import { decode } from '../../../../../../../Overarching Resources/TS/Survey/surveyHelperMethods'

export default {
   methods: {
    returnDictionaryItem(encodedString) {

        if (!encodedString) return ''

        const decoded = decode(encodedString)
        if (decoded) {

            let thePhrase = this.$store.getters['dash/specificLanguagePack'](decoded.languagePackSlug)[decoded.slug]    

            if (thePhrase.indexOf('[businessname]') >= 0) {
                return thePhrase.replaceAll('[businessname]', this.$store.state.dash.viewData.business.businessInfo.businessName)
            }

            return thePhrase
        } 
        return encodedString          
    }
   }
}